<template>
	<div>
		hello world!
	</div>
</template>

<script>
	export default {
		name: 'OoHeader',
		props: {

		},
		data() {
			return {

			}
		},
		methods: {}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/packages/header/src/main.vue